export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/f5c29e86d3a5b6f06334d35443df7aba.svg";